// extracted by mini-css-extract-plugin
export default {"content":"tab-welcome-letter_content__HRNH1","preview":"tab-welcome-letter_preview__04XlC","buttons":"tab-welcome-letter_buttons__mytLH","main":"tab-welcome-letter_main__6BQFK"};